// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from '@/api.js';
import 'babel-polyfill';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueJsonp from 'vue-jsonp';
import '../../../static/css/style.css';
import IndexView from './index.vue';
import router from './router';

Vue.use(VueJsonp)
Vue.use(VueCookies)
Vue.use(ElementUI)

Vue.prototype.isMobile = function() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}

Vue.prototype.axios = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(IndexView)
})



// WEBPACK FOOTER //
// ./src/views/index/index.js